import { Outlet } from 'react-router-dom';
import { BottomNav } from '@/components/BottomNav';
import { ScrollToTop } from '@/components/ScrollToTop';

// Shared chrome for all authenticated routes. Pages do NOT render their own
// BottomNav — it lives here exactly once.
export function AppShell() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
      <BottomNav />
    </>
  );
}
